import React from 'react';
import ListTitle from '../../common/ListTitle';

const dummyData = new Array(30).fill(null).map(() => ({
  time: '2022-05-13 18:06:25',
  type: 'Login',
  userID: 'G002TestUser03',
  userName: '조진환',
  deviceType: '임 pc',
  os: 'Windows',
  macAddress: '00-E0-4C-68-0B-7E',
  ipAddress: '222.121.60.22',
  deviceModel: 'DESKTOP-GGDI4D',
  messangerVersion: '732',
  osVersion: 'Windows 10',
}));

const ListContainer = () => {
  return (
    <div className="flex flex-col h-[calc(100%_-_10rem)] ">
      <ListTitle
        titles={[
          '시간',
          '종류',
          '사용자ID',
          '사용자 이름',
          '디바이스 종류',
          '운영체제',
          'MAC주소',
          'IP주소',
          '디바이스 모델',
          '메신저 버전',
          'OS버전',
        ]}
      />
      <div className="h-[calc(100%_-_3.1rem)] overflow-auto">
        {dummyData.map((data, i) => (
          <List data={data} key={i} index={i} />
        ))}
      </div>
    </div>
  );
};

interface Data {
  time: string;
  type: string;
  userID: string;
  userName: string;
  deviceType: string;
  os: string;
  macAddress: string;
  ipAddress: string;
  deviceModel: string;
  messangerVersion: string;
  osVersion: string;
}

type Props = {
  data: Data;
  index: number;
};

const List: React.FC<Props> = ({ data, index }) => {
  const dataValue = Object.values(data);

  return (
    <div
      className={`grid grid-cols-11 border-b border-solid py-[0.813rem] border-[#dfe2e8] ${
        index < 1 ? 'bg-[#f1f3f6]' : ''
      }`}
    >
      {dataValue.map((data, i) => (
        <div key={i} className="text-center">
          {data}
        </div>
      ))}
    </div>
  );
};

export default ListContainer;
